import React,{useState} from 'react'
import './App.css';
import Banner from './Components/Banner';
import Footer from './Components/Footer';
import Home from './Components/Home';
import Linkresult from './Components/Linkresult';
import Navbar from './Components/Navbar';

// import Navbar from './Components/Navbar';

import Services from './Components/Services';
import Shortner from './Components/Shortner';


function App() {
  const [inputValue, setInputValue] = useState("");
  return (
    <>
    <Navbar/>
    {/* <Navbar2/> */}
    <Home/>
    <Shortner setInputValue={setInputValue}/>
 
    <Linkresult inputValue={inputValue}/>
    <Services/>
    <Banner/>
    <Footer/>
    </>
  );
}

export default App;
